export enum SpotLightEnum {
  PercentChange = "% change",
  Mean = "mean",
  AbsoluteChange = "absolute-change",
  SampleSize = "sample-size",
}

export * from "./form-fields.enum";
export * from "./tabs-key.enum";
export * from "./params.enum";
